import {
  VStack,
  HStack,
  Center,
  View,
  IconButton,
  Spacer,
  Button,
  Box,
  Icon,
  Text,
  Heading,
  ScrollView,
  Checkbox,
  Flex,
  Input,
  TextArea,
} from 'native-base';
import { PaperAirplaneIcon } from 'react-native-heroicons/solid';
import { theme } from '@breakroom-nx/assets';

export const ChatInput = (props: any) => {
  return (
    <Box pl={'13px'} py={'10px'}>
      {/* CHAT INPUT / SUBMISSION */}
      <HStack alignItems={'flex-end'}>
        <TextArea
          px={4}
          pt={3}
          pb={3}
          flex={'1'}
          placeholder={'Send a message (+100 xp)'}
          placeholderTextColor={'surface.300'}
          borderColor={'transparent'}
          rounded={50}
          fontSize={16}
          alignSelf={'stretch'}
          h={{
            base: '100%',
            md: '200%',
          }}
          color={'white'}
          clearTextOnFocus={true}
          // bg={'surface.100'}
          autoFocus={true}
          _focus={{
            placeholderTextColor: theme.colors.surface[400],
            backgroundColor: theme.colors.surface[200],
            borderColor: 'transparent',
          }}
        />
        <Button style={{ backgroundColor: 'transparent' }}>
          <PaperAirplaneIcon
            style={{ transform: [{ rotate: '90deg' }] }}
            size={25}
            color={theme.colors.primary[300]}
          />
        </Button>
      </HStack>
    </Box>
  );
};
